/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import { ApplicationState } from '../../../data/interfaces';
import { connect } from 'react-redux';
import Notification, { NotificationProps } from '../../ChoreoSystem/Notification/Notification';
import { Box, IconButton } from '@material-ui/core';
import Close from "@material-ui/icons/Close"

interface CloseableBannerProps {
  contents: React.ReactNode,
  notificationProps: NotificationProps,
  open: boolean,
  close: () => void,
}

function CloseableBanner(props: CloseableBannerProps) {
  const { contents, notificationProps, open, close } = props;

  if (!open) {
    return null;
  }

  return (
    <Notification {...notificationProps}>
      <Box display="flex" justifyContent="space-between">
        {contents}
        <IconButton size="small" onClick={close}><Close /></IconButton>
      </Box>
    </Notification>
  );
}

const mapStateToProps = (state: ApplicationState) => {
  return {
    apiReducer: state.apiReducer,
  }
}

export default connect(mapStateToProps)(CloseableBanner);
